<div class="offer-item justify-content-between w-100">
  <div class="d-flex cursor-pointer" [routerLink]="'/offerdetail/' + cardLinkOffer.OfferId">
    <div class="offer-item-image">
      <img class="offer-item-CompanyImageUrl" [src]="cardLinkOffer.CompanyImageUrl | contentImage : '7'" />
    </div>
    <div class="Offer-text-block">
      <p *ngIf="cardLinkOffer.Favorite == 1" class="feature-Offer-text">
        <span class="icon material-icons">star</span>{{ 'fgbcl.card.linking.feature.offer.title' | translate }}
      </p>

      <p class="Offer-header-text">{{ cardLinkOffer?.Content | currentLanguageContent : lcid : 'Name' }}</p>
      <p class="Offer-des-text">
        {{ cardLinkOffer?.Content | currentLanguageContent : lcid : 'description' | shortText : 45 : true }}
      </p>

      <div class="btn-online-instore-block">
        <div *ngIf="cardLinkOffer.OfferLocations == 1 || cardLinkOffer.OfferLocations == 3" class="chip btn-online">
          {{ 'fgbcl.card.linking.succes.offer.online.button.title' | translate }}
        </div>
        <div *ngIf="cardLinkOffer.OfferLocations == 2 || cardLinkOffer.OfferLocations == 3" class="chip btn-instore">
          {{ 'fgbcl.card.linking.succes.offer.instore.button.title' | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="offer-button-block">
    <button
      (click)="offerAction(cardLinkOffer, cardNotLinkModel)"
      class="offer-button"
      [ngClass]="{
        'add-offer': cardLinkOffer.CustomerOfferStatus == 0 && cardLinkOffer.OfferType == 6,
        'added-offer': cardLinkOffer.CustomerOfferStatus == 1 && cardLinkOffer.OfferType == 6,
        'view-offer': cardLinkOffer.OfferType != 6
      }"
    >
      <span
        *ngIf="cardLinkOffer.CustomerOfferStatus == 0 && cardLinkOffer.OfferType == 6"
        class="material-icons align-middle"
        data-testid="offer-icon-add"
      >
        add
      </span>
      <span
        *ngIf="cardLinkOffer.CustomerOfferStatus == 1 && cardLinkOffer.OfferType == 6"
        class="material-icons align-middle"
        data-testid="offer-icon-done"
      >
        done
      </span>
      <span *ngIf="cardLinkOffer.OfferType != 6" class="material-icons align-middle" data-testid="navigate-next-icon"
        >navigate_next</span
      >
    </button>
  </div>
</div>

<ng-template #cardNotLinkModel let-modal>
  <div class="card-not-link-model container p-2 overflow-auto">
    <div class="card-not-link-model-header">
      <span class="icon material-icons">link</span>
      <p class="card-not-link-model-header-title">{{ 'fgbcl.card.linking.link.card.not.link.title' | translate }}</p>
    </div>
    <hr class="horizontal-line" />
    <div class="container">
      <p class="card-not-link-model-description text-center">{{ 'fgbcl.card.linking.card.not.link.description' | translate }}</p>
    </div>
    <div class="card-not-link-model-link-card-button d-flex align-items-center justify-content-center my-4">
      <button class="btn btn-success" (click)="cancel()">
        {{ 'fgbcl.card.linking.model.link.card.button.title' | translate }}
      </button>
    </div>
  </div>
</ng-template>
